import { Avatar, Flex, Tooltip, Typography } from "antd"
import dayjs from "dayjs"
import { useTranslation } from "react-i18next"

import ButtonComponent from "../../../Components/Button"
import Icon from "../../../Icon"
import { dateFormat, statusTextMap, tagMap } from "../../../Utils/utils"

const { Text } = Typography

export const TeamPageCard = ({ record, onSelectRow, isAdmin, externalDemoMode }) => {
  const { t } = useTranslation()

  const { role, access_granted, status, last_active } = record

  const isOwner = role?.id === 1
  const isInvited = status?.toLowerCase() === "invited"

  const handleAction = (type) => onSelectRow(record, type)

  const tagTypeToTextType = {
    success: "success",
    warning: "warning",
    error: "danger",
    danger: "danger"
  }
  const statusTextType = tagTypeToTextType[tagMap[status?.toLowerCase()]] || undefined

  return (
    <div className="team-page-card">
      <Flex gap={12}>
        <Flex vertical gap={4} className="team-page-card__col">
          <Text type="secondary" className="team-page-card__label">
            {t("Name")}
          </Text>
          <Text strong>{record?.name || "—"}</Text>
        </Flex>

        <Flex vertical gap={4} className="team-page-card__col">
          <Text type="secondary" className="team-page-card__label">
            {t("Email")}
          </Text>
          <Flex gap={4} align="center">
            <Text ellipsis={{ tooltip: record?.email }} style={{ maxWidth: "calc(100% - 24px)" }}>
              {record?.email || "—"}
            </Text>
          </Flex>
        </Flex>
      </Flex>
      <Flex gap={12}>
        <Flex vertical gap={4} className="team-page-card__col">
          <Text type="secondary" className="team-page-card__label">
            {t("Role")}
          </Text>
          <Text strong>{role?.name || "—"}</Text>
        </Flex>

        <Flex vertical gap={4} className="team-page-card__col">
          <Text type="secondary" className="team-page-card__label">
            {t("Access granted")}
          </Text>
          <Flex gap={4} align="center">
            <Avatar
              size={20}
              src={access_granted?.photo || undefined}
              style={{
                backgroundColor: access_granted?.photo ? "transparent" : "#225AEA",
                borderRadius: 6,
                border: "none",
                fontSize: 10,
                lineHeight: 1,
                flexShrink: 0,
                boxShadow: "inset 3.5px 3.5px 0px 0px rgba(255,255,255,0.25)"
              }}
            >
              {!access_granted?.photo ? access_granted?.name?.slice(0, 2) || "" : null}
            </Avatar>
            <Text
              ellipsis={{ tooltip: access_granted?.name }}
              style={{ maxWidth: "calc(100% - 24px)" }}
            >
              {access_granted?.name || "—"}
            </Text>
          </Flex>
        </Flex>
      </Flex>

      <Flex gap={12}>
        <Flex vertical gap={4} className="team-page-card__col">
          <Text type="secondary" className="team-page-card__label">
            {t("Status")}
          </Text>
          <Text strong type={statusTextType}>
            {statusTextMap[status] || status || "—"}
          </Text>
        </Flex>

        <Flex vertical gap={4} className="team-page-card__col">
          <Text type="secondary" className="team-page-card__label">
            {t("Last active")}
          </Text>
          {last_active ? (
            <Text
              ellipsis={{
                tooltip: dayjs(last_active).format(`${dateFormat}, h:mm A [(UTC)]`)
              }}
            >
              {dayjs(last_active).format(`${dateFormat}, h:mm A [(UTC)]`)}
            </Text>
          ) : (
            <Text type="secondary">{t("No activity")}</Text>
          )}
        </Flex>
      </Flex>

      {!(record?.role === "Owner" || externalDemoMode) && (
        <Flex gap={8}>
          {record?.role?.id !== 1 && (
            <ButtonComponent
              style={{ flex: 1, height: 36 }}
              icon={<Icon type="settings" />}
              text={t("Edit")}
              onClick={() => handleAction("edit")}
            />
          )}
          {isInvited && (
            <Tooltip title={t("Resend invite")}>
              <ButtonComponent
                style={{ width: 36, height: 36 }}
                icon={<Icon type="arrows_repeat" />}
                onClick={() => handleAction("resend")}
              />
            </Tooltip>
          )}
          {record?.role?.id !== 1 && (
            <ButtonComponent
              style={{ width: 36, height: 36 }}
              icon={<Icon type="delete" />}
              onClick={() => handleAction("delete")}
            />
          )}
        </Flex>
      )}
    </div>
  )
}
